import classNames from "classnames";
import React from "react";

export type ContainerProps = {
    children: React.ReactNode;
    fluid?: boolean | "sm" | "md" | "lg" | "xl";
    className?: string;
};

const Container = ({ children, fluid, className }: ContainerProps) => {
    let containerClass = "container";
    if (fluid === true) {
        containerClass = "container-fluid";
    } else if (fluid) {
        containerClass = `container-${fluid}`;
    }

    return (
        <div className={classNames(containerClass, className)}>{children}</div>
    );
};

export { Container };
